import React, { useState } from "react";
import { ReviewAction, sendReviewEvent } from "../matomoClient";
import { isActiveReview } from "../../pages/applications/applicationDetail/tabs/static/reviewHistory/model";
import { sendReminderEmail } from "../../pages/applications/applicationDetail/tabs/static/reviewHistory/service";
import { AsyncActionButtonOrLink } from "../asyncActionButtonOrLink";
import "./index.css";
import { TooltipMessage } from "../../common/data/TooltipMsg";
import { ModalMessage } from "../../common/data/ModalMsg";
import { errorMsg, successMsg } from "../simpleMessageAlert";
import { AlertMessage } from "../../common/data/AlertMsg";

export const DelegationComponent = (
  {
    status,
    appInfo,
    delegatedByList,
    hasSendReminder,
    maxLines = 3,
  }) => {
  const [visible, setVisible] = useState(false);
  const getChildVisibility = (value) => (value ? null : "none");
  const showMoreText = (
    <span
      className={"linkSpan"}
      onClick={() => {
        setVisible(true);
      }}
    >
      Show more ...
    </span>
  );

  const showLessText = (
    <span
      className={"linkSpan"}
      onClick={() => {
        setVisible(false);
      }}
    >
      Show less
    </span>
  );

  let modifiedList = [];
  let remainingChildrenInvisible = false;

  delegatedByList.forEach(({ name, totalTasks, completedTasks }, index) => {
    if (index === maxLines) {
      remainingChildrenInvisible = true;
    }
    if (name === "Unassigned") {
      modifiedList.push(
        <tr key={name}>
          <td>{`${name}`} </td>
          <td style={{ width: "80px" }}> {`${completedTasks} of ${totalTasks}`}</td>
        </tr>,
      );
    } else {
      if (remainingChildrenInvisible) {
        modifiedList.push(
          <tr
            key={name}
            style={{ display: getChildVisibility(visible) }}
          >
            <td>{`${name}`} </td>
            <td style={{ width: "80px" }}> {`${completedTasks} of ${totalTasks}`}</td>
          </tr>,
        );
      } else {
        modifiedList.push(
          <tr key={name}>
            <td>{`${name}`} </td>
            <td style={{ width: "80px" }}> {`${completedTasks} of ${totalTasks}`}</td>
          </tr>,
        );
      }
    }
  });

  function showMoreOrLess() {
    let needsExpandFeature = modifiedList.length > maxLines ? true : false;
    return (
      <div>
        {needsExpandFeature ? (getChildVisibility(visible) ? showMoreText : showLessText) : null}
      </div>
    );
  }

  // eslint-disable-next-line no-unused-vars
  function sendReminderBtn() {
    let btn = null;
    if (!hasSendReminder || !isActiveReview(status)) {
      return null;
    }
    let okCallback = async () => {
      sendReviewEvent(ReviewAction.SendReminder, appInfo.name);
      await sendReminderEmail(appInfo.id)
        .then(() => {
          successMsg(AlertMessage.sendReminder.success);
        })
        .catch(() => {
          errorMsg(AlertMessage.sendReminder.error);
        });
    };

    btn = (
      <AsyncActionButtonOrLink
        linkText={"Send Reminder"}
        type={"link"}
        tooltipText={TooltipMessage.sendReminder}
        modalProps={{
          content: ModalMessage.sendReminderEmail.confirmationMsg,
          title: ModalMessage.sendReminderEmail.title,
          className: "start-modal",
        }}
        modalOkButtonProps={{
          okCallback: okCallback,
        }}
      />
    );
    return btn;
  }

  return (
    <div className="delegationComponent">
      <table className="delegationTable">
        <tbody>{modifiedList}</tbody>
      </table>
      {showMoreOrLess()}
    </div>
  );
};
